import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Header, Footer } from "./components";
import { Home, CollateralDetail, PreSalesDetail, DownloadRequest, Bookmark, Chatbot } from "./pages";
import AuthWrapper from "./components/AuthWrapper";
import { Toaster as Sonner } from "./components/ui/sonner";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";

function Layout() {
  const location = useLocation();

  const isChatbot = location.pathname.startsWith("/help-desk");

  return (
    <>
      {!isChatbot && <Header />}

      <Routes>
        <Route path="/" element={<AuthWrapper><Home /></AuthWrapper>} />
        <Route
          path="/collateral/:tag/:slug"
          element={<AuthWrapper><CollateralDetail /></AuthWrapper>}
        />
        <Route
          path="/presales"
          element={<AuthWrapper><Home initialModule="PreSales" /></AuthWrapper>}
        />
        <Route
          path="/presales/:category/:id"
          element={<AuthWrapper><PreSalesDetail /></AuthWrapper>}
        />
        <Route
          path="/download-request"
          element={<AuthWrapper><DownloadRequest /></AuthWrapper>}
        />
        <Route
          path="/my-library"
          element={<AuthWrapper><Bookmark /></AuthWrapper>}
        />
        <Route
          path="/help-desk"
          element={<AuthWrapper><Chatbot /></AuthWrapper>}
        />
      </Routes>

      {!isChatbot && <Footer />}
    </>

  );
}


function App() {
  return (
    <TooltipProvider>
      {/* ✅ Toast providers */}
      <Toaster />
      <Sonner />

      {/* ✅ Single router */}
      <Router>
        <Layout />
      </Router>
    </TooltipProvider>
  );
}


export default App;